export default function GuideIcon({
  size = 20,
  ...rest
}: {
  size?: number;
  [key: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6.28906C3 5.24477 3.41484 4.24325 4.15327 3.50483C4.89169 2.7664 5.89321 2.35156 6.9375 2.35156H15.6875C16.0356 2.35156 16.3694 2.48984 16.6156 2.73598C16.8617 2.98213 17 3.31597 17 3.66406V16.7891C17 17.0211 16.9078 17.2437 16.7437 17.4078C16.5796 17.5719 16.3571 17.6641 16.125 17.6641H6.0625C5.32594 17.6643 4.61398 17.399 4.05713 16.9169C3.50028 16.4347 3.13585 15.7681 3.03062 15.0391H3V6.28906ZM15.6875 12.8516H6.0625C5.59837 12.8516 5.15325 13.0359 4.82506 13.3641C4.49687 13.6923 4.3125 14.1374 4.3125 14.6016C4.3125 15.0657 4.49687 15.5108 4.82506 15.839C5.15325 16.1672 5.59837 16.3516 6.0625 16.3516H15.6875V12.8516ZM6.71875 6.28906C6.71875 6.11501 6.78789 5.94809 6.91096 5.82502C7.03403 5.70195 7.20095 5.63281 7.375 5.63281H13.5C13.674 5.63281 13.841 5.70195 13.964 5.82502C14.0871 5.94809 14.1562 6.11501 14.1562 6.28906C14.1562 6.46311 14.0871 6.63003 13.964 6.7531C13.841 6.87617 13.674 6.94531 13.5 6.94531H7.375C7.20095 6.94531 7.03403 6.87617 6.91096 6.7531C6.78789 6.63003 6.71875 6.46311 6.71875 6.28906ZM7.375 8.25781C7.20095 8.25781 7.03403 8.32695 6.91096 8.45002C6.78789 8.57309 6.71875 8.74001 6.71875 8.91406C6.71875 9.08811 6.78789 9.25503 6.91096 9.3781C7.03403 9.50117 7.20095 9.57031 7.375 9.57031H11.75C11.924 9.57031 12.091 9.50117 12.214 9.3781C12.3371 9.25503 12.4062 9.08811 12.4062 8.91406C12.4062 8.74001 12.3371 8.57309 12.214 8.45002C12.091 8.32695 11.924 8.25781 11.75 8.25781H7.375Z"
        fill="black"
      />
    </svg>
  );
}
